import { Link } from "react-router-dom";
import { useWishlist } from "../Context/WishlistContext";
import { products } from "../data/products";
import ProductCard from "../components/ProductCard";

export default function Wishlist() {
  const { wishlistIds } = useWishlist();

  // Re-map IDs to product objects securely
  const wishlistedProducts = wishlistIds
    .map(id => products.find(p => p.id === id))
    .filter((p): p is typeof products[0] => p !== undefined);

  return (
    <div className="container">
      <h1 style={{ marginBottom: '24px' }}>My Wishlist ({wishlistedProducts.length})</h1>
      {wishlistedProducts.length === 0 ? (
        <div className="card" style={{ padding: '32px', textAlign: 'center' }}>
          <h2>Your wishlist is empty</h2>
          <p style={{ marginBottom: '20px' }}>Browse our shop and tap the heart icon to save items here for later!</p>
          <Link to="/shop" className="btn-primary">Browse Shop</Link>
        </div>
      ) : (
        <div className="grid">
          {wishlistedProducts.map(p => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
